import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homeSubContext, trackNav } from '../lib/tagitTrack';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 880px)').matches : false,
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 880px)');
    const update = () => {
      const nextMobile = media.matches;
      setIsMobile(nextMobile);
      if (!nextMobile) {
        setMobileOpen(false);
      }
    };

    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link
          to="/#top"
          className="brand"
          aria-label="Knotiv home"
          onClick={() => setMobileOpen(false)}
        >
          <img className="brand-wordmark" src="/brand/knotiv/knotiv-wordmark-light.svg" alt="Knotiv" />
        </Link>

        <nav className="nav-links" aria-label="Primary">
          <Link to="/features" onClick={() => trackNav('features', 'nav')}>
            Features
          </Link>
          <a
            href="https://tagit.gitbook.io/tagit"
            target="_blank"
            rel="noreferrer noopener"
            onClick={() => {
              trackNav(homeSubContext('documents'), 'external_click');
            }}
          >
            Documents
          </a>
          <a href="https://app.knotiv.com" target="_blank" rel="noreferrer noopener">
            Open app
          </a>
        </nav>

        <button
          type="button"
          className="nav-menu"
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {mobileOpen && isMobile ? (
        <div className="nav-drawer" role="navigation" aria-label="Mobile primary">
          <div className="container nav-drawer-inner">
            <Link
              to="/features"
              onClick={() => {
                trackNav('features', 'nav');
                setMobileOpen(false);
              }}
            >
              Features
            </Link>
            <a
              href="https://tagit.gitbook.io/tagit"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => {
                trackNav(homeSubContext('documents'), 'external_click');
                setMobileOpen(false);
              }}
            >
              Documents
            </a>
            <a
              href="https://app.knotiv.com"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => {
                setMobileOpen(false);
              }}
            >
              Open app
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}
